<template>
<div id="main-content" class="taskboard">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12">
          <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
          <ul class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
            <li class="breadcrumb-item">Apps</li>
            <li class="breadcrumb-item active">Tickets</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="header">
            <h2>Employee Detail</h2>
          </div>
          <div class="body">
            <div class="row">
              <div class="form-group col-3">
                <label for="subject">First Name</label>
                <input type="text" class="form-control" v-model="employee.firstName" id="first-name" aria-describedby="subject">
              </div>
              <div class="form-group col-3">
                <label for="subject">Last Name</label>
                <input type="text" class="form-control" v-model="employee.lastName" id="last-name" aria-describedby="subject">
              </div>
              <div class="form-group col-3">
                <label for="subject">Employee ID</label>
                <input type="text" class="form-control" v-model="employee.employeeId" id="employee-id" aria-describedby="subject">
              </div>
              <div class="form-group col-3">
                <label for="subject">Email</label>
                <input type="text" class="form-control" v-model="employee.email" id="email" aria-describedby="subject">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-6">
                <label for="subject">Department</label>
                <app-lookup-field :model="employee" :element="departmentLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
              </div>
            </div>
            <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" @click="cancel">Close Page <i class="far fa-window-close"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import api from '../services/api'
import { Employee } from '../models/employee'
import { prettifyErrorMessage } from '../utils'
import AppDropdown from '../components/AppDropdown.vue'
import AppLookupField from '../components/AppLookupField.vue'

export default {
  components: {
    AppDropdown, AppLookupField
  },
  data() {
    return {
      employee: {
        ...Employee
      },
      departmentLookup: {
        id: 'department',
        title: 'List of Department',
        type: 'form',
        apiUrl: 'department',
        filter: ['name'],
        fields: [
          {
            placeholder: 'Department Name',
            // width: 4,
            column: 'departmentName'
          }
        ],
        dtElements: [
          {
            title: 'Department Name',
            column: 'name'
          },
        ],
        affectedField: [
          {
            from: 'id',
            to: 'departmentId'
          },
          {
            from: 'name',
            to: 'departmentName'
          }
        ]
      },
    }
  },
  async created() {
    const areaApi = api('area')
    this.areaList = await areaApi.get()

    if(this.$route.query.id !== undefined) {
      const empApi = api('employee')
      const empResult = await empApi.getWithParams(this.$route.query.id)
      this.employee = empResult
    }
  },
  methods: {
    async save() {
      const empApi = api('employee')
      if(this.$route.query.id !== undefined) {
        await empApi.update(this.employee, this.$route.query.id)
      } else {
        await empApi.create(this.employee)
      }
      this.$router.go(-1)
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentEmployee = this.employee
      this.employee = {
          ...currentEmployee,
          ...data
      }
    }
  }
}
</script>